import script from "./QuestionWizard.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionWizard.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionWizard.vue?vue&type=style&index=0&id=a908a8d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a908a8d2"]])

export default __exports__